import React from "react";
import { Box } from "@mui/material";
import { BrandContext } from "../../App";
import { useAuth } from "../../contexts/AuthContext";
import HomeProgramCard from "../../components/complex/HomeProgramCard";
import PreviousResultsChart from "../../components/complex/PreviousResultsChart";

import PageTitle from "../../components/PageTitle/PageTitle";

export default function DashboardHome() {
  const { brand } = React.useContext(BrandContext);
  const { loggedInUser } = useAuth();

  React.useEffect(() => {
    let title;
    if (loggedInUser && loggedInUser.first_name) {
      title = `${loggedInUser.first_name}'s Dashboard - ${brand.name}`;
    } else {
      title = `${brand.name} Dashboard`
    }
     document.title = title;
  }, [loggedInUser, brand.name]);

  return (
    <React.Fragment>
      {loggedInUser.first_name && (
        <PageTitle text={`Welcome, ${loggedInUser.first_name}!`} />
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: 0,
        }}
      >
        <HomeProgramCard />
        <PreviousResultsChart />
      </Box>
    </React.Fragment>
  );
}
